import { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

export type LockReason = 'notConfirmed' | 'notEligible' | 'noGoats';

/** Почему закрыты блоки козочек на всём лендинге: решение одно, принимается в `landing.tsx`. */
export const LockReasonContext = createContext<LockReason>('notConfirmed');

/**
 * Замочек на блоках с козочками и лотереей, пока участник не подтвердил участие
 * (landing, «Скрытие баланса до подтверждения участия»), и на поле лотереи, когда
 * неоткрытых козочек нет (landing, «Замочек на поле лотереи без козочек»), и навсегда — тому,
 * кто не участвует в акции (landing, «Уведомление неучаствующему участнику»).
 */
export function LockedBadge({
  hint = false,
  className,
  reason: reasonProp,
}: {
  hint?: boolean;
  className?: string;
  /** Не задана — причина лендинга из LockReasonContext. */
  reason?: LockReason;
}) {
  const { t } = useTranslation('landing');
  const landingReason = useContext(LockReasonContext);
  const reason = reasonProp ?? landingReason;
  const texts =
    reason === 'noGoats'
      ? { aria: t('locked.noGoats.aria'), hint: t('locked.noGoats.hint') }
      : reason === 'notEligible'
        ? { aria: t('locked.notEligible.aria'), hint: t('locked.notEligible.hint') }
        : { aria: t('locked.aria'), hint: t('locked.hint') };
  return (
    <span className={className ? `lockbadge ${className}` : 'lockbadge'} role="img" aria-label={texts.aria}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
        <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
        <circle cx="12" cy="15.5" r="1.2" fill="currentColor" stroke="none" />
      </svg>
      {hint && <span className="lockhint">{texts.hint}</span>}
    </span>
  );
}
